import colors from "../../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const MaturityLevelStyle = makeStyles((theme) => ({
	tooltip: {
		backgroundColor: colors.white,
		width: "100%",
		color: colors.black,
		padding: "10px",
		fontSize: "12px",
		margin: "0px",
	},
	tooltipBackground: (props) => ({
		backgroundColor: props.color,
		color: props.textColor,
		display: "inline-flex",
		alignItems: "center",
		fontWeight: 600,
		padding: "20px 20px",
		height: "40px",
		marginLeft: "8px",
	}),
}));

export default MaturityLevelStyle;
